import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import Papa from "papaparse";
import exportFromJSON from "export-from-json";
import axios from "../services/axios";
import swal from "sweetalert";
import $ from "jquery";
import { Button } from "reactstrap";
import { Card } from "antd";
import isConsultant from "../services/isConsultant";

//datatable
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

const QuestonBank = (props) => {
  const [addques, setAddQues] = useState("");
  const [toggleTextArea, toggleSetTextArea] = useState(false);
  const [question, setQuestion] = useState("");
  const [keyword, setKeyword] = useState("");
  const [previewId, setPreviewId] = useState("");
  const [previewQues, setPreviewQues] = useState("");
  const [previewKeyword, setPreviewKeyword] = useState("");
  const [disabledtext, setDisabledtext] = useState("");
  const [duration, setDuration] = useState("");
  const [previewduration, setpreviewDuration] = useState("");
  const [formError, setFormError] = useState("");
  const [keywordError, setKeywordError] = useState("");
  const [allQuestionData, setAllQuestionData] = useState();
  console.log("allquestiondata", allQuestionData);

  //datatable
  useEffect(() => {
    // $("#table-datatable").DataTable({
    //   columnDefs: [{ type: "date", targets: [5] }],
    //   order: [[5, "desc"]], //or asc
    // });
    setTimeout(() => {
      $("#table-datatable").DataTable({
        order: [[3, "desc"]],
        columnDefs: [{ targets: 3, type: "date" }],
        stateSave: true,
        bDestroy: true,
        responsive: true,
      });
    }, 2000);
  });

  useEffect(() => {
    loadQuestions();
  }, []);

  // candidate load
  function loadQuestions() {
    axios
      .get("questionBank/AllQuestion", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        console.log("questionsss", res?.data);
        setAllQuestionData(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleEditSingleQuestion = (e) => {
    console.log("sainisss", e?.target.getAttribute("question"));
    setPreviewQues(e?.target.getAttribute("question"));
    setPreviewKeyword(e?.target.getAttribute("keywords"));
    setPreviewId(e?.target.getAttribute("id"));
    console.log("id", e?.target.getAttribute("id"));
  };

  const handleSubmitEdittedQuestion = (e) => {
    var data = JSON.stringify({
      questionId: previewId,
      question: previewQues,
      keywords: previewKeyword.split(",").join(" "),
    });

    var config = {
      method: "put",
      url: "/questionBank",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        swal({
          title: "Data submitted Successfully!",
          text: "You clicked the button!",
          icon: "success",
        });
        setTimeout(() => {
          console.log(window.location.reload());
        }, 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleDeleteQuestion = (e) => {
    const questionId = e.target.getAttribute("id");
    axios
      .delete("questionBank/" + questionId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        swal({
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover the question!",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            swal("Poof! Your question has been deleted!", {
              icon: "success",
            });
          }
          window.location.reload();
        });
      })
      .catch(console.error);
  };

  //add question button
  const handleAddQues = () => {
    toggleSetTextArea(true);
  };

  //add question form
  const handlequestion = (e) => {
    const quesData = e.target.value;

    var regExp = /[a-zA-Z]/g;

    if (regExp.test(quesData)) {
      setFormError("");
      if (quesData.length <= 10) {
        setFormError("minimum 10 characters allowed");
      }
      /* do something if letters are found in your string */
    } else {
      setFormError("please include some letters");
    }
    setQuestion(quesData);
    setPreviewQues(quesData);
  };

  //add keyword form
  const handlekeyword = (e) => {
    const keywordsData = e.target.value;
    var regExp = /[a-zA-Z]/g;

    if (regExp.test(keywordsData)) {
      setKeywordError("");
      /* do something if letters are found in your string */
    } else {
      setKeywordError("please include some keywords");
    }
    setKeyword(keywordsData);
    setPreviewKeyword(keywordsData);
  };

  //first submit question form
  const handleSubmitQues = (e) => {
    e.preventDefault();
    // console.log("ques", previewQues);
    //console.log("key", previewKeyword);
    setDisabledtext("disabled");

    setQuestion("");
    setKeyword("");
    setDuration("");
    toggleSetTextArea(false);
  };

  //final submit of modal form
  const handleFinalSubmit = (e) => {
    e.preventDefault();

    const keywordSplit = previewKeyword.split(",");

    const keywordAfterTrim = keywordSplit.map((el) => el.trim());

    axios
      .post(
        "questionBank",
        {
          question: previewQues,
          keywords: keywordSplit.join(" "),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        // console.log(res.data);
        swal({
          title: "Submitted!",
          text: "successful",
          icon: "success",
        });
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //upload csv
  const handleupload = () => {
    //settoggleupload(true);
    toggleSetTextArea(false);
  };

  const [errorData, setErrorData] = useState(false);

  useEffect(() => {
    if (errorData === true) {
      setcsvfileError(
        "some data only contains whitespace (ie. spaces, tabs or line breaks)"
      );
    }
  });
  //csv submit
  const [csvdata, setcsvdata] = useState("");
  const [submitcsvdata, setsubmitcsvdata] = useState("");
  const [csvfileError, setcsvfileError] = useState("");
  //console.log(" submit csv data", submitcsvdata);

  const handlecsvdata = (e) => {
    const files = e.target.files;
    let selectedFile = e.target.files[0];
    let size = selectedFile.size / 1000000;

    // console.log("csv size",size)
    if (size < 5) {
      if (files) {
        //  console.log(files[0]);
        Papa.parse(files[0], {
          header: true,
          complete: function (results) {
            // console.log("Finished:", results.data);
            setErrorData(false);
            setcsvdata(results.data);

            console.log("lengthhsss", results.data.length);
            const finaldata = results.data;
            if (results.data.length < 2) {
              setcsvfileError("no data found");
            } else {
              for (let i = 0; i < finaldata.length - 1; i++) {
                if (
                  finaldata[i].question === "" ||
                  finaldata[i].keywords === ""
                ) {
                  console.log("empty data at line", i + 1);
                  //setErrorData(true);
                  setcsvfileError("some cells are empty");
                }
                var str = "" + finaldata[i].question;
                var str2 = "" + finaldata[i].keywords;

                if (
                  !str.replace(/\s/g, "").length ||
                  !str2.replace(/\s/g, "").length
                ) {
                  setErrorData(true);
                  console.log(
                    "string only contains whitespace (ie. spaces, tabs or line breaks)"
                  );
                  setcsvfileError(
                    "some data only contains whitespace (ie. spaces, tabs or line breaks)"
                  );
                }
                var regExp = /[a-zA-Z]/g;

                if (regExp.test(str) && regExp.test(str2)) {
                  setcsvfileError("");
                  if (str.length <= 10) {
                    setcsvfileError(
                      "some questions contains less than 10 characters"
                    );
                  }
                  /* do something if letters are found in your string */
                } else {
                  setcsvfileError("some cells do not contain letters");
                }
              }

              for (let i = 0; i < 1; i++) {
                //  console.log("name of bulk", finaldata[0]);
                const objkey = finaldata[0];
                // console.log("keys in data", Object.keys(objkey)[1]);
                const question = Object.keys(objkey)[0];
                const keywords = Object.keys(objkey)[1];

                // console.log("finalllllllllll", name, email, phone, source);
                if (question !== "question" || keywords !== "keywords") {
                  setcsvfileError("Headers are mismatched");
                }
              }
            }
          },
        });
      }
    } else {
      setcsvfileError("file size should be less than 5 mb");
    }
  };

  const handleSubmitCsv = (e) => {
    e.preventDefault();

    if (csvdata !== "" && csvfileError === "") {
      // console.log("csv data submitted", csvdata);
      setsubmitcsvdata(csvdata);
      setcsvfileError("");
      let questionsData = [];
      for (let i = 0; i < csvdata.length - 1; i++) {
        // console.log("ffffff",csvdata[i].keywords.split(","))
        let keywordAftertrim = csvdata[i].keywords.split(",");
        let data = {
          question: csvdata[i].question,
          keywords: keywordAftertrim.join(" "),
        };
        //  console.log("wowwwwww", data);
        questionsData.push(data);
        console.log("doneee", questionsData);
        axios
          .post(
            "questionBank/bulkQuestion",
            {
              questions: questionsData,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user.token")}`,
              },
            }
          )
          .then((res) => {
            // console.log(res.data);
            swal({
              title: "Submitted!",
              text: "successful",
              icon: "success",
            });
            // toggleSetTextArea(true);
            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  //csv sample data
  let data = [
    {
      question: "Question?",
      keywords: "test1,test2,test3",
    },
  ];
  const exportType = "csv";
  const handleClickSample = () => {
    exportFromJSON({ data, exportType });
  };

  return (
    <div>
      {!isConsultant() && <Dashboard title="Question Bank">
        <div className="w-100">
          <div>
            <table id="table-datatable" className="table bg-white">
              <thead>
                <tr>
                  <th className="col-md-7">Questions</th>
                  <th className="col-md-3">Keywords</th>
                  <th className="col-md-2">
                    <div className="d-flex justify-content-center align-items-center">
                      Actions
                    </div>
                  </th>
                  <th style={{ display: "none" }}>time</th>
                </tr>
              </thead>
              <tbody>
                {allQuestionData?.map((ele, k) => (
                  <tr key={k}>
                    <td>{ele?.question}</td>
                    <td>{ele?.keywords?.split(" ").join(",")}</td>
                    <td>
                      <div className="d-flex justify-content-center align-items-center">
                        <Button
                          color="info"
                          size="sm"
                          question={ele?.question}
                          keywords={ele?.keywords}
                          id={ele?._id}
                          onClick={handleEditSingleQuestion}
                          data-toggle="modal"
                          data-target="#editModal"
                          className="btn btn-primary"
                          value="Submit Button"
                        >
                          <i class="fa fa-edit"></i> Edit
                        </Button>
                        <Button
                          color="danger"
                          size="sm"
                          id={ele?._id}
                          onClick={handleDeleteQuestion}
                        >
                          <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                          Delete
                        </Button>
                      </div>
                    </td>
                    <td style={{ display: "none" }}>{ele?.createdAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="btn-group btn-group-justified mt-4 w-100">
          <div className="d-flex gap-3 align-items-center flex-wrap mx-auto">
            <button href="#" className="btn btn-primary" onClick={handleAddQues}>
              Add Question
            </button>

            {/* bulk upload csv  */}
            <button
              data-toggle="modal"
              data-target="#bulkModal"
              href="#"
              className="btn btn-primary"
              onClick={handleupload}
            >
              Bulk Upload
            </button>

            {/* download sample button  */}
            <button onClick={handleClickSample} className="btn btn-primary">
              Download Sample
            </button>
          </div>

          <div className="modal fade" id="bulkModal" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Upload CSV File</h4>
                  <button type="button" className="close" data-dismiss="modal">
                    &times;
                  </button>
                  <h4 className="modal-title"></h4>
                </div>
                <div className="modal-body">
                  <div className="py-3 bg-white">
                    <br></br>
                    <form className="form-group" autoComplete="off">
                      <div className="App align-items-center d-flex gap-1 ">
                        <div className="w-50">
                          <input
                            type="file"
                            accept=".csv"
                            onChange={handlecsvdata}
                            required
                          />
                          {csvfileError && (
                            <div
                              className="text-danger"
                              style={{ marginTop: 5 + "px" }}
                            >
                              {csvfileError}
                            </div>
                          )}
                        </div>
                        <div className="w-50">
                          <button
                            className="btn btn btn-primary btn-block"
                            type="submit"
                            onClick={handleSubmitCsv}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="modal-footer"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="m-4">
          {/* add question form  */}
          {toggleTextArea === true ? (
            <div className="row justify-content-center">
              <div className="col-md-6">
                <Card className="border">
                  <form>
                    <div className="form-group">
                      <label>Question?</label>
                      <textarea
                        value={question}
                        onChange={handlequestion}
                        className="form-control"
                        rows="3"
                        placeholder="Add Question here.."
                      ></textarea>
                      {formError && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {formError}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Keywords</label>
                      <textarea
                        value={keyword}
                        onChange={handlekeyword}
                        className="form-control"
                        rows="1"
                        placeholder="eg : text1,text2,text3"
                      ></textarea>
                      {keywordError && (
                        <div
                          className="text-danger"
                          style={{ marginTop: 5 + "px" }}
                        >
                          {keywordError}
                        </div>
                      )}
                    </div>
                    {/* <div className="form-group">
              <label for="comment">Duration (mins)</label>
              <input
               value={duration}
                type="number"
                className="form-control"
                min="1"
                style={{ width: "75px" }}
                onChange={(e)=>{
                  setDuration(e.target.value)
                  setpreviewDuration(e.target.value)
                }}
              />
            </div> */}
                    {question !== "" &&
                    keyword !== "" &&
                    formError === "" &&
                    keywordError === "" ? (
                      <button
                        type="submit"
                        onClick={handleSubmitQues}
                        data-toggle="modal"
                        data-target="#myModal"
                        className="btn btn-primary"
                        value="Submit Button"
                      >
                        submit
                      </button>
                    ) : (
                      <div></div>
                    )}
                  </form>
                </Card>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
        {/* add question modal */}
        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h3>Preview</h3>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Question?</label>
                  <textarea
                    disabled={disabledtext}
                    value={previewQues}
                    onChange={handlequestion}
                    className="form-control"
                    rows="3"
                    placeholder="Add Question here.."
                  ></textarea>
                  {formError && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {formError}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label>Keywords</label>
                  <textarea
                    disabled={disabledtext}
                    value={previewKeyword}
                    onChange={handlekeyword}
                    className="form-control"
                    rows="1"
                    placeholder="eg : text1,text2,text3"
                  ></textarea>
                  {keywordError && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {keywordError}
                    </div>
                  )}
                </div>
                {/* <div className="form-group">
              <label for="comment">Duration (mins)</label>
              <input
               disabled={disabledtext}
               value={previewduration}
                type="number"
                className="form-control"
                min="1"
                style={{ width: "75px" }}
                onChange={(e)=>{
                  setpreviewDuration(e.target.value)
                }}
              />
            </div> */}
              </div>
              <div className="modal-footer">
                {previewKeyword !== "" &&
                previewQues !== "" &&
                formError === "" &&
                keywordError === "" ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleFinalSubmit}
                  >
                    Submit
                  </button>
                ) : (
                  <div></div>
                )}

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    setDisabledtext("");
                  }}
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Single question modal */}
        <div className="modal fade" id="editModal" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="mb-0">Edit Question and Keywords</h5>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Question?</label>
                  <textarea
                    value={previewQues}
                    onChange={handlequestion}
                    className="form-control"
                    rows="3"
                    placeholder="Add Question here.."
                  ></textarea>
                  {formError && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {formError}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label>Keywords</label>
                  <textarea
                    value={previewKeyword.split(" ").join(",")}
                    onChange={handlekeyword}
                    className="form-control"
                    rows="1"
                    placeholder="eg : text1,text2,text3"
                  ></textarea>
                  {keywordError && (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      {keywordError}
                    </div>
                  )}
                </div>
                <div>
                  {previewKeyword !== "" &&
                  previewQues !== "" &&
                  formError === "" &&
                  keywordError === "" ? (
                    <div className="d-flex gap-3">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmitEdittedQuestion}
                      >
                        Submit
                      </button>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                {/* <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    setDisabledtext("");
                  }}
                >
                  Edit
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </Dashboard>}
    </div>
  );
};

export default QuestonBank;
